import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { Tailwind } from 'styles/tw';

type Props = {
  topDecorationImageUrl?: string;
  backgroundImageUrl?: string;
  paddingY: Tailwind['paddingY'];
  titleImage: {
    url: string;
    width: number;
    height: number;
  };
  topLeftImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  topRightImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  bottomLeftImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  bottomCenterImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  bottomRightImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  backgroundColor?: Tailwind['backgroundColor'];
  gap?: {
    mobile: Tailwind['gap'];
    desktop: Tailwind['gap'];
  };
  content: ReactNode;
};

export const CouponDetail: FC<Props> = ({
  topDecorationImageUrl,
  backgroundImageUrl,
  paddingY,
  titleImage,
  topLeftImage,
  topRightImage,
  bottomLeftImage,
  bottomCenterImage,
  bottomRightImage,
  backgroundColor = 'bg-transparent',
  gap = {
    mobile: 'gap-5',
    desktop: 'gap-6'
  },
  content
}) => (
  <section
    className={classNames(
      'flex flex-col relative px-0 xs:px-2',
      `${gap.mobile} semiLg:${gap.desktop}`,
      backgroundImageUrl && 'bg-repeat bg-center bg-cover',
      backgroundColor,
      paddingY
    )}
    style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : '' }}
  >
    {topDecorationImageUrl && (
      <div className="absolute left-1/2 transform -translate-x-1/2 -top-10">
        <NextImage src={topDecorationImageUrl} alt="top-decoration" width={116} height={60} />
      </div>
    )}
    {topLeftImage && (
      <div className="semiLg:hidden absolute top-0 left-0">
        <NextImage
          src={topLeftImage.url}
          alt="top-left-decoration"
          width={topLeftImage.mobileWidth}
          height={topLeftImage.mobileHeight}
        />
      </div>
    )}
    {topLeftImage && (
      <div className="hidden semiLg:flex absolute top-0 left-0">
        <NextImage
          src={topLeftImage.url}
          alt="top-left-decoration"
          width={topLeftImage.desktopWidth}
          height={topLeftImage.desktopHeight}
        />
      </div>
    )}
    {topRightImage && (
      <div className="semiLg:hidden absolute top-0 right-0 aspect-[810/1117]">
        <NextImage
          src={topRightImage.url}
          alt="top-right-decoration"
          width={topRightImage.mobileWidth}
          height={topRightImage.mobileHeight}
        />
      </div>
    )}
    {topRightImage && (
      <div className="hidden semiLg:flex absolute top-0 right-0 aspect-[810/1117]">
        <NextImage
          src={topRightImage.url}
          alt="top-right-decoration"
          width={topRightImage.desktopWidth}
          height={topRightImage.desktopHeight}
        />
      </div>
    )}
    <div className="flex justify-center">
      <NextImage src={titleImage.url} alt="" width={titleImage.width} height={titleImage.height} />
    </div>
    {content}
    {bottomLeftImage && (
      <div className="semiLg:hidden absolute bottom-0 left-0 flex">
        <NextImage
          src={bottomLeftImage.url}
          alt="bottom-left-decoration"
          width={bottomLeftImage.mobileWidth}
          height={bottomLeftImage.mobileHeight}
        />
      </div>
    )}
    {bottomLeftImage && (
      <div className="hidden semiLg:flex absolute bottom-0 left-0">
        <NextImage
          src={bottomLeftImage.url}
          alt="bottom-left-decoration"
          width={bottomLeftImage.desktopWidth}
          height={bottomLeftImage.desktopHeight}
        />
      </div>
    )}
    {bottomCenterImage && (
      <div className="semiLg:hidden absolute bottom-0 left-1/2 transform -translate-x-1/2 flex">
        <NextImage
          src={bottomCenterImage.url}
          alt="bottom-center-decoration"
          width={bottomCenterImage.mobileWidth}
          height={bottomCenterImage.mobileHeight}
        />
      </div>
    )}
    {bottomCenterImage && (
      <div className="hidden semiLg:flex absolute bottom-0 left-1/2 transform -translate-x-1/2">
        <NextImage
          src={bottomCenterImage.url}
          alt="bottom-center-decoration"
          width={bottomCenterImage.desktopWidth}
          height={bottomCenterImage.desktopHeight}
        />
      </div>
    )}
    {bottomRightImage && (
      <div className="semiLg:hidden absolute bottom-0 right-0 flex">
        <NextImage
          src={bottomRightImage.url}
          alt="bottom-right-decoration"
          width={bottomRightImage.mobileWidth}
          height={bottomRightImage.mobileHeight}
        />
      </div>
    )}
    {bottomRightImage && (
      <div className="hidden semiLg:flex absolute bottom-0 right-0">
        <NextImage
          src={bottomRightImage.url}
          alt="bottom-right-decoration"
          width={bottomRightImage.desktopWidth}
          height={bottomRightImage.desktopHeight}
        />
      </div>
    )}
  </section>
);
